import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, INLINES} from '@contentful/rich-text-types'

import {Grid, Footnotes, InlineLink} from '@primer/react-brand'

import {getAnalyticsEvent, documentToPlainTextString} from '@github-ui/swp-core/lib/utils/analytics'
import type {RichText} from '@github-ui/swp-core/schemas/contentful/richText'

import type {GenericGroup, GenericContent} from '../../../../../brand/lib/types/contentful'

function renderRichText(richText: RichText, index: number) {
  return documentToReactComponents(richText, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => [children],
      [INLINES.HYPERLINK]: (node, children) => (
        <InlineLink
          href={node.data.uri}
          {...getAnalyticsEvent({
            action: documentToPlainTextString(node, ' '),
            tag: 'link',
            context: `#footnote-${index + 1}`,
            location: 'footnotes',
          })}
        >
          {children}
        </InlineLink>
      ),
    },
  })
}

type Props = {
  contentfulContent: GenericGroup
}

export function FootnotesSection(props: Props) {
  const {contentfulContent} = props

  const footnotes = contentfulContent.fields.content as GenericContent[]

  return (
    <section id="footnotes" className="lp-Section lp-Section--level-1 lp-Section--footnotes" style={{paddingTop: '0'}}>
      <Grid className="lp-Grid--noRowGap">
        <Grid.Column span={12}>
          <Footnotes>
            {footnotes.map((item, index) => {
              const {text} = item.fields

              if (text === undefined) return null

              return (
                <Footnotes.Item key={index} id={`footnote-ref-${index + 1}`} href={`#footnote-${index + 1}`}>
                  {renderRichText(text, index)}
                </Footnotes.Item>
              )
            })}
          </Footnotes>
        </Grid.Column>
      </Grid>
    </section>
  )
}

try{ FootnotesSection.displayName ||= 'FootnotesSection' } catch {}